import {
  clearAdminSession,
  getAdminToken,
} from "./adminAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_ADMIN_API_BASE_URL ||
  "http://secondbite-manage.localhost/admin-api/v1"
).replace(/\/+$/, "");

export const getAdminDashboard = async () => {
  let response;

  try {
    response = await fetch(`${API_BASE_URL}/dashboard`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getAdminToken()}`,
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }

  const payload = await response.json().catch(() => null);

  if (response.status === 401) {
    clearAdminSession();
    window.location.replace("/login");
    throw new Error("Your session has expired.");
  }

  if (!response.ok || !payload?.success) {
    throw new Error(payload?.message || "Unable to load dashboard.");
  }

  return payload.data;
};

export const exportAdminDashboard = async () => {
  let response;

  try {
    response = await fetch(`${API_BASE_URL}/dashboard/export`, {
      headers: {
        Accept: "text/csv",
        Authorization: `Bearer ${getAdminToken()}`,
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }

  if (response.status === 401) {
    clearAdminSession();
    window.location.replace("/login");
    throw new Error("Your session has expired.");
  }

  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    throw new Error(payload?.message || "Unable to export dashboard report.");
  }

  const disposition = response.headers.get("Content-Disposition") || "";
  const filenameMatch = disposition.match(/filename="?([^"]+)"?/i);
  const filename = filenameMatch?.[1] || "secondbite-dashboard.csv";
  const downloadUrl = URL.createObjectURL(await response.blob());
  const link = document.createElement("a");

  link.href = downloadUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(downloadUrl);
};
